<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Add Admin</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <router-link :to="`/Admias`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Admins >
            </router-link>
            <a class="breadcrumb-item" href="#">Add Admin</a>
          </nav>
        </div>
      </div>
      <AdminForm :product="null" :isEdit="false"></AdminForm>
    </div>
  </div>
</template>

<script>
import AdminForm from '@/components/AdminForm'
/* eslint-disable no-undef */
export default {
  name: 'AddAdmin',
  components: {
    AdminForm
  },
  data () {
    return {}
  },
  mounted () {
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $('#thumbnail').on('change', function (event) {
      var elem = $(this)
      var reader = new FileReader()
      var image = ''
      reader.readAsDataURL(event.target.files[0])
      reader.onload = function () {
        image = reader.result
        elem.attr('data-img', image)
        $('.thumbnail-display').css('background-image', 'url(' + image + ')')
      }
    })
  },
  methods: {}
}
</script>

<style scoped>
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/AddAdmin.vue